import { render, staticRenderFns } from "./SendStatement.vue?vue&type=template&id=2e741130&scoped=true&"
import script from "./SendStatement.vue?vue&type=script&lang=js&"
export * from "./SendStatement.vue?vue&type=script&lang=js&"
import style0 from "./SendStatement.vue?vue&type=style&index=0&id=2e741130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e741130",
  null
  
)

export default component.exports